import { render, staticRenderFns } from "./InputSwitcher.vue?vue&type=template&id=cac6a40c&"
import script from "./InputSwitcher.vue?vue&type=script&lang=js&"
export * from "./InputSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./InputSwitcher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports